export interface SentMessageForPreview {
    bodyPreview?: string | null;
    createdAt: string;
}

export interface ReceivedMessageForPreview {
    bodyPreview?: string | null;
    receivedTimestamp: string;
}

export const pickEmailThreadPreview = (
    sentMessages: SentMessageForPreview[],
    mailboxMessages: ReceivedMessageForPreview[],
): string => {
    const newestSent = sentMessages[0];
    const newestReceived = mailboxMessages[0];
    if (!newestSent) {
        return newestReceived?.bodyPreview ?? "";
    }
    if (!newestReceived) {
        return newestSent.bodyPreview ?? "";
    }
    const receivedIsNewer =
        new Date(newestReceived.receivedTimestamp) > new Date(newestSent.createdAt);
    return (receivedIsNewer ? newestReceived : newestSent).bodyPreview ?? "";
};
